// extracted by mini-css-extract-plugin
module.exports = {"section":"seo-text_section__05rKy","heading":"seo-text_heading__I_7w8","inner":"seo-text_inner__rw7rk","content":"seo-text_content__muvcM","sub-title":"seo-text_sub-title__zTWQf"};